export const FUTURE_STATE_DOMAIN = 'futureState' as const;

export const futureStateDomainDescription =
  'The user is editing a future state of an initiative: proposals, optionally in ' +
  'groups, that describe how the architecture should change. Tools and APIs ' +
  'call them claims and claim groups; say proposals and groups to the user. ' +
  'Delegate requests to add, change, remove, regroup or fix proposals or groups ' +
  'to handle_ui_command, which drafts them for the user to accept. ' +
  'Only draft proposals through handle_ui_command; never save claims or claim ' +
  'groups with any other tool. The UI-command specialist cannot look ' +
  'anything up. If the request adds components or references, first look up ' +
  'both ids and put them in the instruction, never just a type name. ' +
  'get_metamodel_fields returns the workspace id but not the type id; get the ' +
  'type id with resolve_entity_by_name. Answer requests for an explanation or ' +
  'analysis normally. The UI-command specialist decides which actions are ' +
  'available this turn.';
